export default "__VITE_ASSET__yXECE9K8__"